import { NodeSection } from "../props/node/constants";
import { ParentTree } from "../misc/ParentTree";
export var BuildParentTreeVisitor = {
  NodeTree: function NodeTree(path, state) {
    state.parentTree = new ParentTree();
  },
  Node: {
    enter: function enter(path, state) {
      state.currentNodeId = path.params.nodeId;
    },
    enterChild: function enterChild(path) {
      if (path.params.section !== NodeSection.CHILDREN) this.skip();
    }
  },
  AdaptiveDecorator: {
    enterChild: function enterChild(path, state) {
      if (!path.params.matchesInterval(state.opts)) this.skip();
    }
  },
  FieldsDecorator: {
    enterChild: function enterChild(path, state) {
      // FIXME: types
      state.currentFieldId = path.node.fieldId;
    }
  },
  ListOfIdentifiers: function ListOfIdentifiers(path, state) {
    var currentNodeId = state.currentNodeId,
      currentFieldId = state.currentFieldId;
    var value = path.node.value;
    value.forEach(function (nodeId) {
      state.parentTree.setNodeParent(nodeId, {
        parentId: currentNodeId,
        fieldId: currentFieldId
      });
    });
  }
};